import { InjectionToken } from '@angular/core';

import { PersonModuleConfiguration } from './models/configuration';

export const PersonConfigurationService = new InjectionToken<PersonModuleConfiguration>('PersonModuleConfiguration');
